import fetch from 'isomorphic-unfetch';
import { backOff } from 'exponential-backoff';

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (typeof args[args.length - 1] !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var CART_ITEM_PROPS = ['featuredMedia', 'title', 'variant', 'quantity', 'id', 'handle', 'vendor', 'tags', 'metafields'];

var NacelleData = /*#__PURE__*/function () {
  function NacelleData(params) {
    this.connector = params.connector;
    this.locale = params.locale || 'en-us';
    this.currencyCode = params.currencyCode || 'USD';
    this.afterSubscriptions = [];
    this.onDataError = null;

    if (params.onDataError) {
      this.onDataError = params.onDataError;
    }

    this.connector.updateDefaults({
      locale: this.locale
    });
  }

  var _proto = NacelleData.prototype;

  _proto.update = function update(params) {
    if (params.connector) {
      this.connector = params.connector;
    }

    if (params.locale) {
      this.locale = params.locale;
      this.connector.updateDefaults({
        locale: this.locale
      });
    }

    if (params.currencyCode) {
      this.currencyCode = params.currencyCode;
    }

    if (typeof params.onDataError !== 'undefined') {
      this.onDataError = params.onDataError;
    }
  };

  _proto.product = /*#__PURE__*/function () {
    var _product = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(params, connector) {
      var _product2;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (connector || this.connector).product(params);

            case 3:
              _product2 = _context.sent;
              return _context.abrupt("return", this.applyAfter('product', _product2));

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (!this.onDataError) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", this.onDataError({
                method: 'product',
                params: params,
                error: _context.t0
              }));

            case 11:
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));

    function product(_x, _x2) {
      return _product.apply(this, arguments);
    }

    return product;
  }();

  _proto.products = /*#__PURE__*/function () {
    var _products = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(params, connector) {
      var _products2;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (connector || this.connector).products(params);

            case 3:
              _products2 = _context2.sent;
              return _context2.abrupt("return", this.applyAfter('products', _products2));

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              if (!this.onDataError) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", this.onDataError({
                method: 'products',
                params: params,
                error: _context2.t0
              }));

            case 11:
              throw _context2.t0;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 7]]);
    }));

    function products(_x3, _x4) {
      return _products.apply(this, arguments);
    }

    return products;
  }();

  _proto.collection = /*#__PURE__*/function () {
    var _collection = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(params, connector) {
      var _collection2;

      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (connector || this.connector).collection(params);

            case 3:
              _collection2 = _context3.sent;
              return _context3.abrupt("return", this.applyAfter('collection', _collection2));

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              if (!this.onDataError) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", this.onDataError({
                method: 'collection',
                params: params,
                error: _context3.t0
              }));

            case 11:
              throw _context3.t0;

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 7]]);
    }));

    function collection(_x5, _x6) {
      return _collection.apply(this, arguments);
    }

    return collection;
  }();

  _proto.collectionPage = /*#__PURE__*/function () {
    var _collectionPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(params, connector) {
      var products;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (connector || this.connector).collectionPage(params);

            case 3:
              products = _context4.sent;
              return _context4.abrupt("return", this.applyAfter('collectionPage', products));

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              if (!this.onDataError) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", this.onDataError({
                method: 'collectionPage',
                params: params,
                error: _context4.t0
              }));

            case 11:
              throw _context4.t0;

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 7]]);
    }));

    function collectionPage(_x7, _x8) {
      return _collectionPage.apply(this, arguments);
    }

    return collectionPage;
  }();

  _proto.content = /*#__PURE__*/function () {
    var _content = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(params, connector) {
      var _content2;

      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (connector || this.connector).content(params);

            case 3:
              _content2 = _context5.sent;
              return _context5.abrupt("return", this.applyAfter('content', _content2));

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);

              if (!this.onDataError) {
                _context5.next = 11;
                break;
              }

              return _context5.abrupt("return", this.onDataError({
                method: 'content',
                params: params,
                error: _context5.t0
              }));

            case 11:
              throw _context5.t0;

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 7]]);
    }));

    function content(_x9, _x10) {
      return _content.apply(this, arguments);
    }

    return content;
  }();

  _proto.page = /*#__PURE__*/function () {
    var _page = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(params, connector) {
      var _page2;

      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (connector || this.connector).page(params);

            case 3:
              _page2 = _context6.sent;
              return _context6.abrupt("return", this.applyAfter('page', _page2));

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);

              if (!this.onDataError) {
                _context6.next = 11;
                break;
              }

              return _context6.abrupt("return", this.onDataError({
                method: 'page',
                params: params,
                error: _context6.t0
              }));

            case 11:
              throw _context6.t0;

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[0, 7]]);
    }));

    function page(_x11, _x12) {
      return _page.apply(this, arguments);
    }

    return page;
  }();

  _proto.pages = /*#__PURE__*/function () {
    var _pages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(params, connector) {
      var _pages2;

      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (connector || this.connector).pages(params);

            case 3:
              _pages2 = _context7.sent;
              return _context7.abrupt("return", this.applyAfter('pages', _pages2));

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);

              if (!this.onDataError) {
                _context7.next = 11;
                break;
              }

              return _context7.abrupt("return", this.onDataError({
                method: 'pages',
                params: params,
                error: _context7.t0
              }));

            case 11:
              throw _context7.t0;

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this, [[0, 7]]);
    }));

    function pages(_x13, _x14) {
      return _pages.apply(this, arguments);
    }

    return pages;
  }();

  _proto.article = /*#__PURE__*/function () {
    var _article = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(params, connector) {
      var _article2;

      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return (connector || this.connector).article(params);

            case 3:
              _article2 = _context8.sent;
              return _context8.abrupt("return", this.applyAfter('article', _article2));

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);

              if (!this.onDataError) {
                _context8.next = 11;
                break;
              }

              return _context8.abrupt("return", this.onDataError({
                method: 'article',
                params: params,
                error: _context8.t0
              }));

            case 11:
              throw _context8.t0;

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[0, 7]]);
    }));

    function article(_x15, _x16) {
      return _article.apply(this, arguments);
    }

    return article;
  }();

  _proto.articles = /*#__PURE__*/function () {
    var _articles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(params, connector) {
      var _articles2;

      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return (connector || this.connector).articles(params);

            case 3:
              _articles2 = _context9.sent;
              return _context9.abrupt("return", this.applyAfter('articles', _articles2));

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);

              if (!this.onDataError) {
                _context9.next = 11;
                break;
              }

              return _context9.abrupt("return", this.onDataError({
                method: 'articles',
                params: params,
                error: _context9.t0
              }));

            case 11:
              throw _context9.t0;

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 7]]);
    }));

    function articles(_x17, _x18) {
      return _articles.apply(this, arguments);
    }

    return articles;
  }();

  _proto.blog = /*#__PURE__*/function () {
    var _blog = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(params, connector) {
      var _blog2;

      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return (connector || this.connector).blog(params);

            case 3:
              _blog2 = _context10.sent;
              return _context10.abrupt("return", this.applyAfter('blog', _blog2));

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);

              if (!this.onDataError) {
                _context10.next = 11;
                break;
              }

              return _context10.abrupt("return", this.onDataError({
                method: 'blog',
                params: params,
                error: _context10.t0
              }));

            case 11:
              throw _context10.t0;

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[0, 7]]);
    }));

    function blog(_x19, _x20) {
      return _blog.apply(this, arguments);
    }

    return blog;
  }();

  _proto.blogPage = /*#__PURE__*/function () {
    var _blogPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(params, connector) {
      var articles;
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return (connector || this.connector).blogPage(params);

            case 3:
              articles = _context11.sent;
              return _context11.abrupt("return", this.applyAfter('blogPage', articles));

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);

              if (!this.onDataError) {
                _context11.next = 11;
                break;
              }

              return _context11.abrupt("return", this.onDataError({
                method: 'blogPage',
                params: params,
                error: _context11.t0
              }));

            case 11:
              throw _context11.t0;

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this, [[0, 7]]);
    }));

    function blogPage(_x21, _x22) {
      return _blogPage.apply(this, arguments);
    }

    return blogPage;
  }();

  _proto.space = /*#__PURE__*/function () {
    var _space = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12(connector) {
      var _space2;

      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return (connector || this.connector).space();

            case 3:
              _space2 = _context12.sent;
              return _context12.abrupt("return", this.applyAfter('space', _space2));

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12["catch"](0);

              if (!this.onDataError) {
                _context12.next = 11;
                break;
              }

              return _context12.abrupt("return", this.onDataError({
                method: 'space',
                params: {},
                error: _context12.t0
              }));

            case 11:
              throw _context12.t0;

            case 12:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this, [[0, 7]]);
    }));

    function space(_x23) {
      return _space.apply(this, arguments);
    }

    return space;
  }();

  _proto.allProducts = /*#__PURE__*/function () {
    var _allProducts = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(params, connector) {
      var products;
      return runtime_1.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return (connector || this.connector).allProducts(params);

            case 3:
              products = _context13.sent;
              return _context13.abrupt("return", this.applyAfter('allProducts', products));

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](0);

              if (!this.onDataError) {
                _context13.next = 11;
                break;
              }

              return _context13.abrupt("return", this.onDataError({
                method: 'allProducts',
                params: params,
                error: _context13.t0
              }));

            case 11:
              throw _context13.t0;

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this, [[0, 7]]);
    }));

    function allProducts(_x24, _x25) {
      return _allProducts.apply(this, arguments);
    }

    return allProducts;
  }();

  _proto.allCollections = /*#__PURE__*/function () {
    var _allCollections = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14(params, connector) {
      var collections;
      return runtime_1.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return (connector || this.connector).allCollections(params);

            case 3:
              collections = _context14.sent;
              return _context14.abrupt("return", this.applyAfter('allCollections', collections));

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](0);

              if (!this.onDataError) {
                _context14.next = 11;
                break;
              }

              return _context14.abrupt("return", this.onDataError({
                method: 'allCollections',
                params: params,
                error: _context14.t0
              }));

            case 11:
              throw _context14.t0;

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this, [[0, 7]]);
    }));

    function allCollections(_x26, _x27) {
      return _allCollections.apply(this, arguments);
    }

    return allCollections;
  }();

  _proto.allContent = /*#__PURE__*/function () {
    var _allContent = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15(params, connector) {
      var content;
      return runtime_1.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return (connector || this.connector).allContent(params);

            case 3:
              content = _context15.sent;
              return _context15.abrupt("return", this.applyAfter('allContent', content));

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](0);

              if (!this.onDataError) {
                _context15.next = 11;
                break;
              }

              return _context15.abrupt("return", this.onDataError({
                method: 'allContent',
                params: params,
                error: _context15.t0
              }));

            case 11:
              throw _context15.t0;

            case 12:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this, [[0, 7]]);
    }));

    function allContent(_x28, _x29) {
      return _allContent.apply(this, arguments);
    }

    return allContent;
  }();

  _proto.after = function after(method, callback) {
    this.afterSubscriptions.push({
      method: method,
      callback: callback
    });
  };

  _proto.applyAfter = /*#__PURE__*/function () {
    var _applyAfter = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee16(method, responseObj) {
      var response, subs, _iterator, _step, sub;

      return runtime_1.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              response = responseObj;
              subs = this.afterSubscriptions.filter(function (sub) {
                return sub.method === method;
              });
              _iterator = _createForOfIteratorHelperLoose(subs);

            case 3:
              if ((_step = _iterator()).done) {
                _context16.next = 10;
                break;
              }

              sub = _step.value;
              _context16.next = 7;
              return sub.callback(response);

            case 7:
              response = _context16.sent;

            case 8:
              _context16.next = 3;
              break;

            case 10:
              return _context16.abrupt("return", response);

            case 11:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function applyAfter(_x30, _x31) {
      return _applyAfter.apply(this, arguments);
    }

    return applyAfter;
  }();

  _proto.formatItemsForCart = function formatItemsForCart(items) {
    var _this = this;

    return items.map(function (item) {
      var _this$validateCartIte = _this.validateCartItemProperties(item),
          isValid = _this$validateCartIte.isValid,
          missingKeys = _this$validateCartIte.missingKeys;

      var itemIdentifier = item.id || item.handle || 'unknown';

      if (!isValid) {
        throw new Error("Item " + itemIdentifier + " is missing one or more of the required item fields: " + JSON.stringify(missingKeys));
      }

      return {
        image: item.featuredMedia,
        title: item.title,
        variant: item.variant,
        quantity: item.quantity,
        productId: item.id,
        handle: item.handle,
        vendor: item.vendor,
        tags: item.tags,
        metafields: item.metafields
      };
    });
  };

  _proto.validateCartItemProperties = function validateCartItemProperties(item) {
    var itemKeys = Object.keys(item);
    var missingKeys = CART_ITEM_PROPS.filter(function (prop) {
      return !itemKeys.includes(prop);
    });
    return {
      isValid: missingKeys.length === 0,
      missingKeys: missingKeys
    };
  };

  return NacelleData;
}();

// TODO: update as we learn more with new logging

/**
 * @description Sometimes HF will throw these AppSync request errors as a `NacelleError`.
 * HF should retry these kinds of errors, but up to only a max of 5, which is how they
 * most likely end up making it to the client.
 */
var errorMessageTriggerRetry = ['Endpoint request timed out', 'Request failed with status code 500', 'Request failed with status code 502', 'Request failed with status code 429']; // https://httpstatuses.com/

var retryStatusCodes = [429, 500, 502, 503, 504];
/**
 * @description Some failed requests from Hail Frequency should be retried with
 * an exponential backoff pattern. Particularly if Hail Frequency threw some kind
 * of throttling or rate limiting error response. This function looks at the response
 * object and determines based on status code or error message for GraphQL errors, if
 * the request should be retried.
 *
 * @param response A isomorphic-unfetch response object
 * @param data An object that is the result of `await response.json()`
 * @returns a boolean indicating whether a request should be retried
 */

function shouldRetryRequest(response, data) {
  // TODO: return an object with boolean and optional retryReason string
  if (retryStatusCodes.includes(response.status)) {
    return true;
  }

  if (response.ok) {
    var errors = data == null ? void 0 : data.errors;

    if (errors) {
      var shouldRetry = errors.filter(function (graphqlError) {
        return errorMessageTriggerRetry.some(function (triggerMessage) {
          return graphqlError.message.indexOf(triggerMessage) > -1;
        });
      });
      return shouldRetry.length > 0;
    }
  }

  return false;
}

var backOffOptions = {
  delayFirstAttempt: false,
  jitter: 'full',
  numOfAttempts: 5,
  startingDelay: 100,
  maxDelay: Infinity,
  timeMultiple: 10
};

var HttpClientFetch = /*#__PURE__*/function () {
  function HttpClientFetch(options) {
    var defaultOptions = {
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 240000
    };
    options = options || {};
    this.options = _extends({}, defaultOptions, options);
  }
  /**
   * @description GET data from a given endpoint. Retries with
   * exponential backoff occur on failures.
   *
   * @param url - The url address for the desired endpoint
   */


  var _proto = HttpClientFetch.prototype;

  _proto.get =
  /*#__PURE__*/
  function () {
    var _get = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(url) {
      var _this = this;

      var response, data;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return backOff(function () {
                return fetch(url, _extends({}, _this.options, {
                  method: 'GET'
                }));
              }, backOffOptions);

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();

            case 5:
              data = _context.sent;
              return _context.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data: data
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }()
  /**
   * @description POST data to a given endpoint. Retries with
   * exponential backoff occur on failures (max 10 retries).
   *
   * @param url - The url address for the desired endpoint
   * @param data - The data payload to POST to the endpoint
   */
  ;

  _proto.post =
  /*#__PURE__*/
  function () {
    var _post = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(url, data) {
      var _this2 = this;

      var response;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return backOff( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
                var innerResponse, responseData;
                return runtime_1.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return fetch(url, _extends({}, _this2.options, {
                          method: 'POST',
                          body: JSON.stringify(data)
                        }));

                      case 2:
                        innerResponse = _context2.sent;
                        _context2.next = 5;
                        return innerResponse.json();

                      case 5:
                        responseData = _context2.sent;

                        if (!shouldRetryRequest(innerResponse, responseData)) {
                          _context2.next = 8;
                          break;
                        }

                        throw new Error('Hail Frequency request failed, but should be retried after delay.');

                      case 8:
                        return _context2.abrupt("return", _extends({}, innerResponse, {
                          responseData: responseData
                        }));

                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })), backOffOptions);

            case 2:
              response = _context3.sent;
              return _context3.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data: response.responseData
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function post(_x2, _x3) {
      return _post.apply(this, arguments);
    }

    return post;
  }();

  return HttpClientFetch;
}();

var NacelleConnector = /*#__PURE__*/function () {
  function NacelleConnector(params) {
    this.apiClient = params && params.httpClient ? params.httpClient : new HttpClientFetch();
    this.locale = params && params.locale ? params.locale : 'en-us';
  }

  var _proto = NacelleConnector.prototype;

  _proto.updateDefaults = function updateDefaults(params) {
    if (params && params.locale) {
      this.locale = params.locale;
    }
  };

  _proto.product = /*#__PURE__*/function () {
    var _product = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_options) {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              throw new Error('The default NacelleConnector does not return a product');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function product(_x) {
      return _product.apply(this, arguments);
    }

    return product;
  }();

  _proto.products = /*#__PURE__*/function () {
    var _products = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_options) {
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error('The default NacelleConnector does not return products');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function products(_x2) {
      return _products.apply(this, arguments);
    }

    return products;
  }();

  _proto.collection = /*#__PURE__*/function () {
    var _collection = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(_options) {
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              throw new Error('The default NacelleConnector does not return a collection');

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function collection(_x3) {
      return _collection.apply(this, arguments);
    }

    return collection;
  }();

  _proto.collectionPage = /*#__PURE__*/function () {
    var _collectionPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(_options) {
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              throw new Error('The default NacelleConnector does not return a collection page');

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function collectionPage(_x4) {
      return _collectionPage.apply(this, arguments);
    }

    return collectionPage;
  }();

  _proto.content = /*#__PURE__*/function () {
    var _content = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(_options) {
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              throw new Error('This NacelleConnector does not return a content item');

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function content(_x5) {
      return _content.apply(this, arguments);
    }

    return content;
  }();

  _proto.page = /*#__PURE__*/function () {
    var _page = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(_options) {
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              throw new Error('This NacelleConnector does not return a page item');

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function page(_x6) {
      return _page.apply(this, arguments);
    }

    return page;
  }();

  _proto.pages = /*#__PURE__*/function () {
    var _pages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(_options) {
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              throw new Error('This NacelleConnector does not return pages');

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function pages(_x7) {
      return _pages.apply(this, arguments);
    }

    return pages;
  }();

  _proto.blog = /*#__PURE__*/function () {
    var _blog = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(_options) {
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              throw new Error('This NacelleConnector does not return a blog');

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function blog(_x8) {
      return _blog.apply(this, arguments);
    }

    return blog;
  }();

  _proto.article = /*#__PURE__*/function () {
    var _article = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(_options) {
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              throw new Error('This NacelleConnector does not return an article');

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function article(_x9) {
      return _article.apply(this, arguments);
    }

    return article;
  }();

  _proto.articles = /*#__PURE__*/function () {
    var _articles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(_options) {
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              throw new Error('This NacelleConnector does not return an article');

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function articles(_x10) {
      return _articles.apply(this, arguments);
    }

    return articles;
  }();

  _proto.blogPage = /*#__PURE__*/function () {
    var _blogPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(_options) {
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              throw new Error('This NacelleConnector does not return a blog page');

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function blogPage(_x11) {
      return _blogPage.apply(this, arguments);
    }

    return blogPage;
  }();

  _proto.space = /*#__PURE__*/function () {
    var _space = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12() {
      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              throw new Error('This NacelleConnector does not return a space');

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function space() {
      return _space.apply(this, arguments);
    }

    return space;
  }();

  _proto.allProducts = /*#__PURE__*/function () {
    var _allProducts = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(_options) {
      return runtime_1.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              throw new Error('This NacelleConnector does not return all products');

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function allProducts(_x12) {
      return _allProducts.apply(this, arguments);
    }

    return allProducts;
  }();

  _proto.allCollections = /*#__PURE__*/function () {
    var _allCollections = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14(_options) {
      return runtime_1.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              throw new Error('This NacelleConnector does not return all collections');

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function allCollections(_x13) {
      return _allCollections.apply(this, arguments);
    }

    return allCollections;
  }();

  _proto.allContent = /*#__PURE__*/function () {
    var _allContent = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15(_options) {
      return runtime_1.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              throw new Error('This NacelleConnector does not return all content');

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function allContent(_x14) {
      return _allContent.apply(this, arguments);
    }

    return allContent;
  }();

  return NacelleConnector;
}();

var getList = (function (selectedList, lists) {
  if (selectedList === void 0) {
    selectedList = 'default';
  }

  var selected = lists.find(function (_ref) {
    var slug = _ref.slug;
    return slug === selectedList;
  });

  if (selected !== undefined) {
    return selected;
  } else {
    throw new Error('No default product list found');
  }
});

var getListHandles = (function (lists, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      paginate = _options.paginate,
      selectedList = _options.selectedList,
      _options$index = _options.index,
      index = _options$index === void 0 ? 0 : _options$index,
      _options$itemsPerPage = _options.itemsPerPage,
      itemsPerPage = _options$itemsPerPage === void 0 ? 30 : _options$itemsPerPage;
  var list = getList(selectedList, lists);

  if (list && list.handles) {
    if (paginate) {
      return list.handles.slice(index, index + itemsPerPage);
    }

    return list.handles;
  }

  throw new Error('Selected list does not have array of handles');
});

var createProduct = function createProduct(options) {
  var product = _extends({
    id: '',
    handle: '',
    locale: 'en-us',
    globalHandle: '',
    pimSyncSourceDomain: '',
    title: '',
    description: '',
    priceRange: {
      min: '0.0',
      max: '0.0',
      currencyCode: 'USD'
    },
    availableForSale: true,
    tags: [],
    media: [],
    metafields: [],
    variants: [],
    indexedAt: 0
  }, options);

  return product;
};

var createMedia = function createMedia(options) {
  return _extends({
    id: '',
    type: 'image',
    src: '',
    thumbnailSrc: '',
    altText: ''
  }, options);
};

var createItemList = function createItemList(obj) {
  var list = _extends({
    title: '',
    slug: 'default',
    locale: 'en-us',
    handles: []
  }, obj);

  return list;
};

var _excluded = ["productLists", "featuredMedia"];
var createCollection = function createCollection(obj) {
  var productLists = obj.productLists,
      featuredMedia = obj.featuredMedia,
      rest = _objectWithoutPropertiesLoose(obj, _excluded);

  var collection = _extends({
    id: '',
    handle: '',
    locale: 'en-us',
    globalHandle: '',
    pimSyncSourceDomain: '',
    productLists: [],
    featuredMedia: null
  }, rest, {
    metafields: obj.metafields || []
  });

  if (productLists && Array.isArray(productLists)) {
    collection.productLists = productLists.map(function (list) {
      return createItemList(list);
    });
  }

  if (featuredMedia) {
    collection.featuredMedia = createMedia(featuredMedia);
  }

  return collection;
};

var createFieldsFromTags = (function (tags) {
  if (Array.isArray(tags)) {
    var tagFields = tags.reduce(function (fields, tag) {
      if (tag.includes('field::')) {
        var _tag$split = tag.split('::'),
            key = _tag$split[1],
            value = _tag$split[2];

        fields[key] = value;
      }

      return fields;
    }, {});
    return _extends({}, tagFields);
  }

  return {};
});

var mapContentSections = function mapContentSections(sections, cmsSyncSource) {
  var formattedSections = typeof sections === 'string' ? JSON.parse(sections) : sections;

  if (Array.isArray(formattedSections)) {
    return formattedSections.filter(Boolean).map(function (section) {
      if (section.tags) {
        var fieldTags = createFieldsFromTags(section.tags);
        return _extends({}, section, fieldTags, {
          cmsSyncSource: cmsSyncSource
        });
      }

      return _extends({}, section, {
        cmsSyncSource: cmsSyncSource
      });
    });
  }

  return [];
};

var _excluded$1 = ["articleLists", "featuredMedia", "sections"];
var createContent = function createContent(obj) {
  var articleLists = obj.articleLists,
      featuredMedia = obj.featuredMedia,
      sections = obj.sections,
      rest = _objectWithoutPropertiesLoose(obj, _excluded$1);

  var content = _extends({
    id: '',
    handle: '',
    locale: '',
    globalHandle: '',
    cmsSyncSource: '',
    cmsSyncSourceDomain: '',
    cmsSyncSourceContentId: '',
    type: 'content',
    indexedAt: 0,
    articleLists: null,
    featuredMedia: null,
    relatedArticles: []
  }, rest);

  if (sections) {
    content.sections = mapContentSections(sections, content.cmsSyncSource);
  }

  if (articleLists && Array.isArray(articleLists)) {
    content.articleLists = articleLists.map(function (list) {
      return createItemList(list);
    });
  }

  if (featuredMedia) {
    content.featuredMedia = createMedia(featuredMedia);
  }

  return content;
};

var createSpace = function createSpace(obj) {
  var id = obj.id,
      name = obj.name,
      domain = obj.domain,
      linklists = obj.linklists,
      metafields = obj.metafields,
      pimSyncSourceDomain = obj.pimSyncSourceDomain,
      cmsSyncSourceDomain = obj.cmsSyncSourceDomain;
  var space = {
    id: id || '',
    name: name || '',
    domain: domain || '',
    linklists: Array.isArray(linklists) ? linklists : [],
    metafields: Array.isArray(metafields) ? metafields : [],
    pimSyncSourceDomain: pimSyncSourceDomain || '',
    cmsSyncSourceDomain: cmsSyncSourceDomain || ''
  };
  return space;
};

var mediaFragment = "\n  id\n  thumbnailSrc\n  src\n  type\n  altText\n";

var metafieldFragment = "\n  id\n  namespace\n  key\n  value\n";

var productFragment = "\n  id\n  handle\n  locale\n  globalHandle\n  pimSyncSource\n  pimSyncSourceDomain\n  pimSyncSourceProductId\n  title\n  description\n  priceRange {\n    min\n    max\n    currencyCode\n  }\n  productType\n  media {\n    " + mediaFragment + "\n  }\n  featuredMedia {\n    " + mediaFragment + "\n  }\n  availableForSale\n  vendor\n  tags\n  createdAt\n  metafields {\n    " + metafieldFragment + "\n  }\n  indexedAt\n  variants {\n    id\n    title\n    price\n    priceCurrency\n    compareAtPrice\n    compareAtPriceCurrency\n    swatchSrc\n    selectedOptions {\n      name\n      value\n    }\n    featuredMedia {\n      " + mediaFragment + "\n    }\n    sku\n    availableForSale\n    quantityAvailable\n    metafields {\n      " + metafieldFragment + "\n    }\n    weight\n    weightUnit\n    priceRules {\n      id\n      handle\n      title\n      price\n      priceCurrency\n      comparedAtPrice\n       metafields {\n          " + metafieldFragment + "\n        }\n      priceBreaks {\n        quantityMin\n        quantityMax\n        price\n        metafields {\n          " + metafieldFragment + "\n        }\n      }\n      availableTo\n    }\n  }\n";

var getProductsQuery = "\nquery getProducts($first: Int, $after: String) {\n  getProducts(first: $first, after: $after) {\n    items {\n      " + productFragment + "\n    }\n    nextToken\n  }\n}\n";

var collectionFragment = "\n  id\n  handle\n  globalHandle\n  locale\n  pimSyncSourceDomain\n  pimSyncSource\n  pimSyncSourceCollectionId\n  title\n  description\n  metafields {\n    " + metafieldFragment + "\n  }\n  featuredMedia {\n    " + mediaFragment + "\n  }\n  productLists {\n    title\n    slug\n    locale\n    handles\n  }\n";

var getCollectionsQuery = "\nquery getCollections($first: Int, $after: String) {\n  getCollections(first: $first, after: $after) {\n    nextToken\n    items {\n      " + collectionFragment + "\n    }\n  }\n}\n";

var getContentQuery = "\nquery getContent($first: Int, $after: String, $type: String) {\n  getContent(first: $first, after: $after, type: $type) {\n    nextToken\n    items {\n      id\n      handle\n      locale\n      globalHandle\n      cmsSyncSource\n      cmsSyncSourceDomain\n      cmsSyncSourceContentId\n      type\n      indexedAt\n      title\n      description\n      sections\n      tags\n      fields\n      articleLists {\n        title\n        slug\n        locale\n        handles\n      }\n      relatedArticles {\n        handle\n        title\n        blogHandle\n        cmsSyncSourceContentId\n        locale\n        createdAt\n        updatedAt\n        author {\n          firstName\n          lastName\n          bio\n          email\n        }\n        featuredMedia {\n          " + mediaFragment + "\n        }\n        publishDate\n        description\n        excerpt\n        tags\n      }\n      collectionHandle\n      content\n      contentHtml\n      excerpt\n      blogHandle\n      featuredMedia {\n        " + mediaFragment + "\n      }\n      publishDate\n      author {\n        firstName\n        lastName\n        bio\n        email\n      }\n      createdAt\n      updatedAt\n    }\n  }\n}";

var getSpaceQuery = "\nquery GetSpace {\n  getSpace {\n    id\n    name\n    domain\n    metafields {\n      namespace\n      key\n      value\n    }\n    linklists {\n      handle\n      links {\n        title\n        to\n        type\n        links {\n          title\n          to\n          type\n          links {\n            title\n            to\n            type\n          }\n        }\n      }\n    }\n  }\n}";

var getCheckoutQuery = "\nquery getCheckout($id: ID!, $url: String!) {\n  getCheckout(id: $id, url: $url) {\n    id\n    url\n    completed\n  }\n}\n";

var getVariantAvailabilityQuery = "\nquery GetVariantAvailability($productId: String!, $variantId: String!) {\n  getVariantAvailability(productId: $productId, variantId: $variantId)\n}\n";

var putWishListMutation = "\n  mutation putWishlist ($input: WishlistInput!) {\n    putWishlist (input: $input) {\n      id,\n      customerSourceId,\n      items {\n        variantId\n        handle\n      }\n    }\n  }\n";

var processCheckoutMutation = "\nmutation processCheckout($input: CheckoutInput) {\n  processCheckout(input: $input) {\n    id\n    url\n    completed\n  }\n}\n";

var getProductByHandleQuery = "\nquery getProductByHandle($handle: String!, $locale: String) {\n  getProductByHandle(handle: $handle, locale: $locale) {\n    " + productFragment + "\n  }\n}\n";

var getCollectionByHandleQuery = "\nquery getCollectionByHandle($handle: String!, $locale: String) {\n  getCollectionByHandle(handle: $handle, locale: $locale) {\n    " + collectionFragment + "\n  }\n}\n";

var getContentByHandleQuery = "\nquery getContentByHandle($type: String!, $handle: String!, $locale: String, $blogHandle: String) {\n  getContentByHandle(type: $type, handle: $handle, locale: $locale, blogHandle: $blogHandle) {\n    id\n    handle\n    locale\n    globalHandle\n    cmsSyncSource\n    cmsSyncSourceDomain\n    cmsSyncSourceContentId\n    type\n    indexedAt\n    title\n    description\n    sections\n    tags\n    fields\n    articleLists {\n      title\n      slug\n      locale\n      handles\n    }\n    relatedArticles {\n      handle\n      title\n      blogHandle\n      cmsSyncSourceContentId\n      locale\n      createdAt\n      updatedAt\n      author {\n        firstName\n        lastName\n        bio\n        email\n      }\n      featuredMedia {\n        id\n        type\n        src\n        thumbnailSrc\n        altText\n      }\n      publishDate\n      description\n      excerpt\n      tags\n    }\n    collectionHandle\n    content\n    contentHtml\n    excerpt\n    blogHandle\n    featuredMedia {\n      id\n      type\n      src\n      thumbnailSrc\n      altText\n    }\n    publishDate\n    author {\n      firstName\n      lastName\n      bio\n      email\n    }\n    createdAt\n    updatedAt\n  }\n}";

var batchGetProductsByHandleQuery = "\nquery batchGetProductsByHandle($handles: [String!]!, $locale: String!) {\n  batchGetProductsByHandle(handles: $handles, locale: $locale) {\n    items {\n      " + productFragment + "\n    }\n  }\n}\n";

/**
 * @description - breaks up a large array into batches.
 *
 * @param array
 * @param batchSize {number} number of items in each batch
 * @returns array of batches
 */
function batch(array, batchSize) {
  var R = [];

  for (var i = 0, len = array.length; i < len; i += batchSize) {
    R.push(array.slice(i, i + batchSize));
  }

  return R;
}

var NacelleGraphQLConnector = /*#__PURE__*/function (_NacelleConnector) {
  _inheritsLoose(NacelleGraphQLConnector, _NacelleConnector);

  function NacelleGraphQLConnector(params) {
    var _this;

    _this = _NacelleConnector.call(this, params) || this;

    if (typeof params.endpoint === 'undefined' || params.endpoint === null || params.endpoint === '') {
      throw new Error('NacelleGraphQLConnector requires a valid endpoint.');
    }

    if (typeof params.spaceId === 'undefined' || params.spaceId === null || params.spaceId === '') {
      throw new Error('NacelleGraphQLConnector requires a valid Nacelle space id.');
    }

    if (typeof params.token === 'undefined' || params.token === null || params.token === '') {
      throw new Error('NacelleGraphQLConnector requires a valid Nacelle space API token.');
    }

    _this.endpoint = params.endpoint;
    _this.spaceId = params.spaceId;
    _this.token = params.token;
    _this.apiClient = params && params.httpClient ? params.httpClient : new HttpClientFetch({
      headers: {
        'x-nacelle-space-id': _this.spaceId,
        'x-nacelle-space-token': _this.token
      }
    });
    return _this;
  }

  var _proto = NacelleGraphQLConnector.prototype;

  _proto.request = /*#__PURE__*/function () {
    var _request = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(query, queryName, variables) {
      var data, response, firstError, _firstError$extension, _firstError$extension2, errorId, message;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = {
                query: query,
                variables: variables
              };
              _context.next = 4;
              return this.apiClient.post(this.endpoint, data);

            case 4:
              response = _context.sent;

              if (!response) {
                _context.next = 18;
                break;
              }

              if (!(response.data && Array.isArray(response.data.errors) && response.data.errors.length > 0)) {
                _context.next = 13;
                break;
              }

              firstError = response.data.errors.pop();

              if (!(firstError && firstError.message)) {
                _context.next = 12;
                break;
              }

              errorId = (_firstError$extension = firstError.extensions) != null && _firstError$extension.nacelleErrorId ? " (Nacelle Error Id: " + ((_firstError$extension2 = firstError.extensions) == null ? void 0 : _firstError$extension2.nacelleErrorId) + ")" : '';
              message = "" + firstError.message + errorId;
              throw new Error(message);

            case 12:
              throw new Error("Unknown graphql error attempting " + queryName);

            case 13:
              if (!(response.data.data && typeof response.data.data[queryName] !== 'undefined')) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return", {
                success: true,
                data: response.data.data[queryName]
              });

            case 17:
              throw new Error("Response did not include " + queryName + ".\n            " + JSON.stringify(response.data, null, 2));

            case 18:
              throw new Error("No valid response from " + queryName);

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                success: false,
                error: _context.t0.message,
                data: null
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 21]]);
    }));

    function request(_x, _x2, _x3) {
      return _request.apply(this, arguments);
    }

    return request;
  }();

  _proto.getAllPageItems = /*#__PURE__*/function () {
    var _getAllPageItems = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(params) {
      var after, pages, response, page, items;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              after = '';
              pages = [];

            case 2:
              _context2.next = 4;
              return this.request(params.query, params.queryName, {
                first: params.first || 500,
                after: after,
                type: params.type
              });

            case 4:
              response = _context2.sent;

              if (response.success && response.data) {
                page = response.data;
                pages.push(page);
                after = page.nextToken;
              } else {
                after = '';
              }

            case 6:
              if (after !== '' && (!params.totalReturnedLimit || pages.reduce(function (n, resp) {
                return n + resp.items.length;
              }, 0) < params.totalReturnedLimit)) {
                _context2.next = 2;
                break;
              }

            case 7:
              items = pages.reduce(function (arr, page) {
                if (page && page.items && page.items.length > 0) {
                  return arr.concat(page.items);
                }

                return arr;
              }, []);
              return _context2.abrupt("return", items.slice(0, params.totalReturnedLimit || items.length));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getAllPageItems(_x4) {
      return _getAllPageItems.apply(this, arguments);
    }

    return getAllPageItems;
  }();

  _proto.product = /*#__PURE__*/function () {
    var _product = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(options) {
      var query, response;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = getProductByHandleQuery;
              _context3.next = 3;
              return this.request(this.endpoint.indexOf('v2') > -1 ? query.replace('quantityAvailable', '') : query, 'getProductByHandle', {
                handle: options.handle,
                locale: options.locale || 'en-us'
              });

            case 3:
              response = _context3.sent;

              if (!(response.success && response.data)) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", createProduct(response.data));

            case 6:
              throw new Error(response.error);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function product(_x5) {
      return _product.apply(this, arguments);
    }

    return product;
  }();

  _proto.products = /*#__PURE__*/function () {
    var _products = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(options) {
      var _this2 = this;

      var handles, query, locale, batches, requests, responses, successes;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              handles = options.handles;
              query = this.endpoint.indexOf('v2') > -1 ? batchGetProductsByHandleQuery.replace('quantityAvailable', '') : batchGetProductsByHandleQuery;
              locale = options.locale || this.locale || 'en-us';
              batches = batch(handles, 100);
              requests = batches.map(function (handles) {
                return _this2.request(query, 'batchGetProductsByHandle', {
                  handles: handles,
                  locale: locale
                });
              });
              _context4.next = 7;
              return Promise.all(requests);

            case 7:
              responses = _context4.sent;
              successes = responses.reduce(function (arr, res) {
                if (res.success && res.data) {
                  var _products2 = res.data.items.map(function (product) {
                    return createProduct(product);
                  });

                  arr = arr.concat(_products2);
                }

                return arr;
              }, []);
              return _context4.abrupt("return", successes);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function products(_x6) {
      return _products.apply(this, arguments);
    }

    return products;
  }();

  _proto.collection = /*#__PURE__*/function () {
    var _collection = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(options) {
      var query, response;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              query = getCollectionByHandleQuery;
              _context5.next = 3;
              return this.request(query, 'getCollectionByHandle', {
                handle: options.handle,
                locale: options.locale || 'en-us'
              });

            case 3:
              response = _context5.sent;

              if (!(response.success && response.data)) {
                _context5.next = 6;
                break;
              }

              return _context5.abrupt("return", createCollection(response.data));

            case 6:
              throw new Error(response.error);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function collection(_x7) {
      return _collection.apply(this, arguments);
    }

    return collection;
  }();

  _proto.collectionPage = /*#__PURE__*/function () {
    var _collectionPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(options) {
      var handle, locale, list, paginate, index, itemsPerPage, collection, handles;
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              handle = options.handle, locale = options.locale, list = options.list, paginate = options.paginate, index = options.index, itemsPerPage = options.itemsPerPage;
              collection = options.collection;

              if (!(typeof collection === 'undefined')) {
                _context6.next = 10;
                break;
              }

              if (!(handle && handle.length > 0)) {
                _context6.next = 9;
                break;
              }

              _context6.next = 6;
              return this.collection({
                handle: handle,
                locale: locale
              });

            case 6:
              collection = _context6.sent;
              _context6.next = 10;
              break;

            case 9:
              throw new Error('A collection or handle is required');

            case 10:
              handles = getListHandles(collection.productLists, {
                selectedList: list,
                paginate: typeof paginate !== 'undefined' ? paginate : false,
                index: index,
                itemsPerPage: itemsPerPage
              });
              return _context6.abrupt("return", this.products({
                handles: handles,
                locale: locale
              }));

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function collectionPage(_x8) {
      return _collectionPage.apply(this, arguments);
    }

    return collectionPage;
  }();

  _proto.content = /*#__PURE__*/function () {
    var _content = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(_ref) {
      var handle, _ref$type, type, locale, _ref$blogHandle, blogHandle, useLocale, query, response;

      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              handle = _ref.handle, _ref$type = _ref.type, type = _ref$type === void 0 ? 'page' : _ref$type, locale = _ref.locale, _ref$blogHandle = _ref.blogHandle, blogHandle = _ref$blogHandle === void 0 ? 'blog' : _ref$blogHandle;
              useLocale = locale || this.locale;
              query = getContentByHandleQuery;
              _context7.next = 5;
              return this.request(query, 'getContentByHandle', {
                type: type,
                handle: handle,
                locale: useLocale,
                blogHandle: blogHandle
              });

            case 5:
              response = _context7.sent;

              if (!(response.success && response.data)) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return", createContent(response.data));

            case 8:
              throw new Error(response.error);

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function content(_x9) {
      return _content.apply(this, arguments);
    }

    return content;
  }();

  _proto.page = function page(options) {
    return this.content({
      handle: options.handle,
      type: 'page',
      locale: options.locale
    });
  };

  _proto.pages = /*#__PURE__*/function () {
    var _pages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(options) {
      var _this3 = this;

      var handles, locale, useLocale, requests, responses, successes;
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              handles = options.handles, locale = options.locale;
              useLocale = locale || this.locale;
              requests = handles.map(function (handle) {
                return _this3.content({
                  type: 'page',
                  handle: handle,
                  locale: useLocale
                })["catch"](function () {
                  return undefined;
                });
              });
              _context8.next = 5;
              return Promise.all(requests);

            case 5:
              responses = _context8.sent;
              successes = responses.reduce(function (arr, response) {
                if (response) {
                  arr.push(response);
                }

                return arr;
              }, []);
              return _context8.abrupt("return", successes);

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function pages(_x10) {
      return _pages.apply(this, arguments);
    }

    return pages;
  }();

  _proto.blog = function blog(options) {
    return this.content({
      handle: options.handle,
      type: 'blog',
      locale: options.locale
    });
  };

  _proto.article = function article(options) {
    return this.content({
      handle: options.handle,
      type: 'article',
      locale: options.locale,
      blogHandle: options.blogHandle || 'blog'
    });
  };

  _proto.articles = /*#__PURE__*/function () {
    var _articles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(options) {
      var _this4 = this;

      var handles, locale, blogHandle, useLocale, requests, responses, successes;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              handles = options.handles, locale = options.locale, blogHandle = options.blogHandle;
              useLocale = locale || this.locale;
              requests = handles.map(function (handle) {
                return _this4.article({
                  handle: handle,
                  blogHandle: blogHandle,
                  locale: useLocale
                })["catch"](function () {
                  return undefined;
                });
              });
              _context9.next = 5;
              return Promise.all(requests);

            case 5:
              responses = _context9.sent;
              successes = responses.reduce(function (arr, response) {
                if (response) {
                  arr.push(response);
                }

                return arr;
              }, []);
              return _context9.abrupt("return", successes);

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function articles(_x11) {
      return _articles.apply(this, arguments);
    }

    return articles;
  }();

  _proto.blogPage = /*#__PURE__*/function () {
    var _blogPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(options) {
      var handle, locale, list, paginate, index, itemsPerPage, blog, handles;
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              handle = options.handle, locale = options.locale, list = options.list, paginate = options.paginate, index = options.index, itemsPerPage = options.itemsPerPage;
              blog = options.blog;

              if (!(typeof blog === 'undefined')) {
                _context10.next = 10;
                break;
              }

              if (!(handle && handle.length > 0)) {
                _context10.next = 9;
                break;
              }

              _context10.next = 6;
              return this.blog({
                handle: handle,
                locale: locale
              });

            case 6:
              blog = _context10.sent;
              _context10.next = 10;
              break;

            case 9:
              throw new Error('A blog or handle is required');

            case 10:
              if (!blog.articleLists) {
                _context10.next = 13;
                break;
              }

              handles = getListHandles(blog.articleLists, {
                selectedList: list,
                paginate: typeof paginate !== 'undefined' ? paginate : false,
                index: index,
                itemsPerPage: itemsPerPage
              });
              return _context10.abrupt("return", this.articles({
                handles: handles,
                locale: locale,
                blogHandle: handle || blog.handle
              }));

            case 13:
              return _context10.abrupt("return", []);

            case 14:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function blogPage(_x12) {
      return _blogPage.apply(this, arguments);
    }

    return blogPage;
  }();

  _proto.allProducts = /*#__PURE__*/function () {
    var _allProducts = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(params) {
      var query, products;
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              query = getProductsQuery;
              _context11.next = 3;
              return this.getAllPageItems({
                query: this.endpoint.indexOf('v2') > -1 ? query.replace('quantityAvailable', '') : query,
                queryName: 'getProducts',
                first: params && params.queryLimit ? params.queryLimit : 500,
                totalReturnedLimit: params && params.limit ? params.limit : undefined
              });

            case 3:
              products = _context11.sent;
              return _context11.abrupt("return", products.map(function (product) {
                return createProduct(product);
              }));

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function allProducts(_x13) {
      return _allProducts.apply(this, arguments);
    }

    return allProducts;
  }();

  _proto.allCollections = /*#__PURE__*/function () {
    var _allCollections = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12(params) {
      var query, collections;
      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              query = getCollectionsQuery;
              _context12.next = 3;
              return this.getAllPageItems({
                query: query,
                queryName: 'getCollections',
                first: params && params.queryLimit ? params.queryLimit : 500,
                totalReturnedLimit: params && params.limit ? params.limit : undefined
              });

            case 3:
              collections = _context12.sent;
              return _context12.abrupt("return", collections.map(function (collection) {
                return createCollection(collection);
              }));

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function allCollections(_x14) {
      return _allCollections.apply(this, arguments);
    }

    return allCollections;
  }();

  _proto.allContent = /*#__PURE__*/function () {
    var _allContent = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(params) {
      var _$exec, _$exec$groups;

      var hailFrequencyVersion, apiVersionSupportsContentByType, query, content;
      return runtime_1.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              // using a capture group named 'version', extract the version from the endpoint
              //  ex: for 'https://hailfrequency.com/v12/graphql', get '12'
              hailFrequencyVersion = ((_$exec = /*#__PURE__*/_wrapRegExp(/v([0-9]+)/, {
                version: 1
              }).exec(this.endpoint || '')) == null ? void 0 : (_$exec$groups = _$exec.groups) == null ? void 0 : _$exec$groups.version) || '0';
              apiVersionSupportsContentByType = Number(hailFrequencyVersion) > 2;
              query = apiVersionSupportsContentByType ? getContentQuery : getContentQuery.replace(', $type: String', '').replace(', type: $type', '');
              _context13.next = 5;
              return this.getAllPageItems(_extends({
                query: query,
                queryName: 'getContent',
                first: params && params.queryLimit ? params.queryLimit : 500,
                totalReturnedLimit: params && params.limit ? params.limit : undefined
              }, apiVersionSupportsContentByType && (params == null ? void 0 : params.type) && {
                type: params && params.type ? params.type : undefined
              }));

            case 5:
              content = _context13.sent;
              return _context13.abrupt("return", content.map(function (entry) {
                return createContent(entry);
              }));

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function allContent(_x15) {
      return _allContent.apply(this, arguments);
    }

    return allContent;
  }();

  _proto.space = /*#__PURE__*/function () {
    var _space = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14() {
      var query, response;
      return runtime_1.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              query = getSpaceQuery;
              _context14.next = 3;
              return this.request(query, 'getSpace');

            case 3:
              response = _context14.sent;

              if (!response) {
                _context14.next = 9;
                break;
              }

              if (!(response.success && response.data)) {
                _context14.next = 7;
                break;
              }

              return _context14.abrupt("return", createSpace(response.data));

            case 7:
              if (!(response && !response.success && response.error)) {
                _context14.next = 9;
                break;
              }

              throw new Error(response.error);

            case 9:
              throw new Error('Invalid response attempting getSpace query');

            case 10:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function space() {
      return _space.apply(this, arguments);
    }

    return space;
  }();

  _proto.processCheckout = /*#__PURE__*/function () {
    var _processCheckout = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15(params) {
      var query, response;
      return runtime_1.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              query = processCheckoutMutation;
              _context15.next = 3;
              return this.request(query, 'processCheckout', {
                input: _extends({}, params)
              });

            case 3:
              response = _context15.sent;

              if (!response) {
                _context15.next = 9;
                break;
              }

              if (!(response.success && response.data)) {
                _context15.next = 7;
                break;
              }

              return _context15.abrupt("return", response.data);

            case 7:
              if (!(response && !response.success && response.error)) {
                _context15.next = 9;
                break;
              }

              throw new Error(response.error);

            case 9:
              throw new Error('Invalid response attempting processCheckout mutation');

            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function processCheckout(_x16) {
      return _processCheckout.apply(this, arguments);
    }

    return processCheckout;
  }();

  _proto.queryCheckout = /*#__PURE__*/function () {
    var _queryCheckout = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee16(params) {
      var query, response;
      return runtime_1.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              query = getCheckoutQuery;
              _context16.next = 3;
              return this.request(query, 'getCheckout', _extends({}, params));

            case 3:
              response = _context16.sent;

              if (!response) {
                _context16.next = 9;
                break;
              }

              if (!(response.success && response.data)) {
                _context16.next = 7;
                break;
              }

              return _context16.abrupt("return", response.data);

            case 7:
              if (!(response && !response.success && response.error)) {
                _context16.next = 9;
                break;
              }

              throw new Error(response.error);

            case 9:
              throw new Error('Invalid response attempting getCheckout query');

            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function queryCheckout(_x17) {
      return _queryCheckout.apply(this, arguments);
    }

    return queryCheckout;
  }();

  _proto.isVariantAvailable = /*#__PURE__*/function () {
    var _isVariantAvailable = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee17(params) {
      var query, response;
      return runtime_1.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              query = getVariantAvailabilityQuery;
              _context17.next = 3;
              return this.request(query, 'getVariantAvailability', _extends({}, params));

            case 3:
              response = _context17.sent;

              if (!response) {
                _context17.next = 9;
                break;
              }

              if (!(response.success && typeof response.data !== 'undefined' && response.data !== null)) {
                _context17.next = 7;
                break;
              }

              return _context17.abrupt("return", response.data);

            case 7:
              if (!(response && !response.success && response.error)) {
                _context17.next = 9;
                break;
              }

              throw new Error(response.error);

            case 9:
              throw new Error('Invalid response attempting getVariantAvailability query');

            case 10:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function isVariantAvailable(_x18) {
      return _isVariantAvailable.apply(this, arguments);
    }

    return isVariantAvailable;
  }();

  return NacelleGraphQLConnector;
}(NacelleConnector);

var NacelleCheckout = /*#__PURE__*/function () {
  function NacelleCheckout(params) {
    if (params.connector) {
      this.connector = params.connector;
    } else if (params.endpoint && params.spaceId && params.token) {
      this.connector = new NacelleGraphQLConnector({
        endpoint: params.endpoint,
        spaceId: params.spaceId,
        token: params.token
      });
    } else {
      throw new Error('Missing parameters to initialize checkout module');
    }
  }

  var _proto = NacelleCheckout.prototype;

  _proto.process = function process(params) {
    return this.connector.processCheckout(params);
  };

  _proto.get = function get(params) {
    if (typeof params.id === 'undefined' || params.id.length === 0) {
      throw new Error('Missing parameter "id". Querying for a checkout requires a checkout Id.');
    }

    if (typeof params.url === 'undefined' || params.url.length === 0) {
      throw new Error('Missing parameter "url". Querying for a checkout requires a checkout url.');
    }

    return this.connector.queryCheckout(params);
  };

  _proto.formatItemsForCheckout = function formatItemsForCheckout(cart) {
    return cart.map(function (item) {
      return {
        cartItemId: item.productId,
        variantId: item.variant.id,
        quantity: item.quantity,
        metafields: item.metafields
      };
    });
  };

  return NacelleCheckout;
}();

var NacelleStatus = /*#__PURE__*/function () {
  function NacelleStatus(params) {
    if (params.connector) {
      this.connector = params.connector;
    } else if (params.endpoint && params.spaceId && params.token) {
      this.connector = new NacelleGraphQLConnector({
        endpoint: params.endpoint,
        spaceId: params.spaceId,
        token: params.token
      });
    } else {
      throw new Error('Missing parameters to initialize checkout module');
    }
  }

  var _proto = NacelleStatus.prototype;

  _proto.isVariantAvailable = function isVariantAvailable(params) {
    return this.connector.isVariantAvailable(params);
  };

  return NacelleStatus;
}();

var getWishlistsByCustomerSourceIdQuery = "\n  query getWishlistsByCustomerSourceId ($customerId: String!, $first: Int, $nextToken: String) {\n    getWishlistsByCustomerSourceId (customerId: $customerId, first: $first, nextToken: $nextToken) {\n      items {\n        id,\n        customerSourceId,\n        title\n        \n        items {\n          variantId\n          handle\n        }\n      }\n      nextToken\n    }\n  }\n";

var getWishlistQuery = "\n  query getWishlist($id: ID!, $customerId: String!){\n    getWishlist (id: $id, customerId: $customerId) {\n      id,\n      title,\n      customerSourceId,\n      items{\n        variantId,\n        handle,\n      }\n    }\n  }\n";

var deleteWishlistQuery = "\n  mutation deleteWishlist ($input: DeleteWishlistInput!) {\n    deleteWishlist (input: $input) {\n      id,\n      customerSourceId,\n      items {\n        variantId\n        handle\n      }\n    }\n  }\n";

var NacelleWishlist = /*#__PURE__*/function () {
  function NacelleWishlist(params) {
    if (params && params.endpoint && params.endpoint.length > 0) {
      this.endpoint = params.endpoint;
    } else if (typeof process !== 'undefined' && process.env && process.env.NACELLE_WISHLIST_ENDPOINT && process.env.NACELLE_WISHLIST_ENDPOINT.length > 0) {
      this.endpoint = process.env.NACELLE_WISHLIST_ENDPOINT;
    } else {
      // Set default Wishlist endpoint
      this.endpoint = 'https://wishlist.hailfrequency.com/graphql';
    }

    var httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        'X-Nacelle-Space-Id': params.spaceId,
        'X-Nacelle-Space-Token': params.token
      }
    };
    this.apiClient = params && params.httpClient ? params.httpClient : new HttpClientFetch(httpOptions);
  }

  var _proto = NacelleWishlist.prototype;

  _proto.put = function put(params) {
    return this.apiClient.post(this.endpoint, {
      query: putWishListMutation,
      variables: {
        input: _extends({}, params)
      }
    });
  };

  _proto.get = function get(params) {
    return this.apiClient.post(this.endpoint, {
      query: getWishlistsByCustomerSourceIdQuery,
      variables: params
    });
  };

  _proto.getById = function getById(params) {
    return this.apiClient.post(this.endpoint, {
      query: getWishlistQuery,
      variables: params
    });
  };

  _proto["delete"] = function _delete(params) {
    return this.apiClient.post(this.endpoint, {
      query: deleteWishlistQuery,
      variables: {
        input: _extends({}, params)
      }
    });
  };

  return NacelleWishlist;
}();

var NacelleRecommendations = /*#__PURE__*/function () {
  function NacelleRecommendations(params) {
    if (params && params.endpoint && params.endpoint.length > 0) {
      this.endpoint = params.endpoint + "/" + params.spaceId + "/v1/";
    } else if (typeof process !== 'undefined' && process.env && process.env.NACELLE_RECOMMENDATIONS_ENDPOINT && process.env.NACELLE_RECOMMENDATIONS_ENDPOINT.length > 0) {
      this.endpoint = process.env.NACELLE_RECOMMENDATIONS_ENDPOINT;
    } else {
      // Set default Recommendations endpoint
      this.endpoint = "https://recommendations.hailfrequency.com/" + params.spaceId + "/v1/";
    }

    var httpOptions = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    this.apiClient = params && params.httpClient ? params.httpClient : new HttpClientFetch(httpOptions);
  }

  var _proto = NacelleRecommendations.prototype;

  _proto.getByProductHandle = /*#__PURE__*/function () {
    var _getByProductHandle = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(options) {
      var handle, locale, useLocale, generatedRecommendations, recommendationsData, rulesRecommendations, merchandisingRulesData, merchandisingRules, recommendations;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handle = options.handle, locale = options.locale;
              useLocale = (locale || 'en-us').toLowerCase();
              generatedRecommendations = [];
              _context.prev = 3;
              _context.next = 6;
              return this.apiClient.get(this.endpoint + "recommendations/products/" + handle + "--" + useLocale + ".json");

            case 6:
              recommendationsData = _context.sent;

              if (recommendationsData) {
                generatedRecommendations = JSON.parse(recommendationsData.data);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.log("Unable to load generated product recommendations for " + handle + ".");

            case 13:
              rulesRecommendations = [];
              _context.prev = 14;
              _context.next = 17;
              return this.apiClient.get(this.endpoint + "merchandising-rules.json");

            case 17:
              merchandisingRulesData = _context.sent;

              if (merchandisingRulesData) {
                merchandisingRules = merchandisingRulesData.data.rules.find(function (rule) {
                  return rule.inputs.includes(handle);
                });
                rulesRecommendations = merchandisingRules ? merchandisingRules.outputs : [];
              }

              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t1 = _context["catch"](14);
              console.log("Unable to load product recommendation rules for " + handle + ".");

            case 24:
              recommendations = [].concat((rulesRecommendations || []).map(function (handle) {
                return {
                  handle: handle,
                  source: 'rule'
                };
              }), (generatedRecommendations || []).filter(function (handle) {
                return !rulesRecommendations.includes(handle);
              }).map(function (handle) {
                return {
                  handle: handle,
                  source: 'generated'
                };
              }));
              return _context.abrupt("return", options.limit ? recommendations.slice(0, options.limit) : recommendations);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 10], [14, 21]]);
    }));

    function getByProductHandle(_x) {
      return _getByProductHandle.apply(this, arguments);
    }

    return getByProductHandle;
  }();

  return NacelleRecommendations;
}();

var EventType;

(function (EventType) {
  EventType["productView"] = "productView";
  EventType["search"] = "search";
  EventType["productRecommendation"] = "productRecommendation";
  EventType["pageView"] = "pageView";
  EventType["collectionView"] = "collectionView";
  EventType["blogView"] = "blogView";
  EventType["articleView"] = "articleView";
  EventType["cartAdd"] = "cartAdd";
  EventType["cartRemove"] = "cartRemove";
  EventType["checkoutInit"] = "checkoutInit";
  EventType["checkoutComplete"] = "checkoutComplete";
})(EventType || (EventType = {}));

var NacelleEvents = /*#__PURE__*/function () {
  function NacelleEvents(params) {
    if (params && params.endpoint && params.endpoint.length > 0) {
      this.endpoint = params.endpoint;
    } else if (typeof process !== 'undefined' && process.env && process.env.NACELLE_TEM_ENDPOINT && process.env.NACELLE_TEM_ENDPOINT.length > 0) {
      this.endpoint = process.env.NACELLE_TEM_ENDPOINT;
    } else {
      // Set default TEM endpoint
      this.endpoint = 'https://tem.hailfrequency.com/events/add';
    }

    this.apiClient = params && params.httpClient ? params.httpClient : new HttpClientFetch();

    if (params && typeof params.disable !== 'undefined') {
      this.disable = params.disable;
    } else {
      this.disable = false;
    }

    this.subscriptions = [];
    this.attributionEvents = {};
  }

  var _proto = NacelleEvents.prototype;

  _proto.log = function log(eventInput) {
    if (this.disable) {
      return;
    }

    updateSessionEventCount();

    var event = _extends({}, eventInput, {
      user: _extends({
        device: getDevice()
      }, eventInput.user)
    }, getUrlParts(eventInput.url), getGlobalEventData());

    var getAttributionData = this.attributionEvents[event.eventType];

    if (getAttributionData) {
      setGlobalEventData({
        attributionType: event.eventType,
        attributionData: getAttributionData(event)
      });
    }

    var modifiedEvent = this.subscriptions.filter(function (_ref) {
      var eventType = _ref.eventType;
      return event.eventType === eventType || eventType === '*';
    }).filter(function (_ref2) {
      var callback = _ref2.callback;
      return !!callback;
    }).map(function (_ref3) {
      var callback = _ref3.callback;
      return callback(event);
    }).reduce(function (acc, cur) {
      return _extends({}, acc, cur);
    }, {});

    var eventToSend = _extends({}, event, modifiedEvent);

    this.apiClient.post(this.endpoint, eventToSend);
  };

  _proto.onAttributionEvent = function onAttributionEvent(eventType, getAttributionData) {
    this.attributionEvents[eventType] = getAttributionData;
  };

  _proto.onEvent = function onEvent(eventType, callback) {
    this.subscriptions.push({
      eventType: eventType,
      callback: callback
    });
  };

  return NacelleEvents;
}();

var getDevice = function getDevice() {
  var globalScope = getGlobalScope();
  var device = globalScope && globalScope.navigator && globalScope.navigator.userAgent ? globalScope.navigator.userAgent.toLowerCase() : 'unknown';
  return device;
};

var getUrlParts = function getUrlParts(url) {
  var globalScope = getGlobalScope();
  var href = globalScope && globalScope.location && globalScope.location.href;
  var parsedUrl = tryCatch(function () {
    return new URL(url || '');
  }, function () {
    return tryCatch(function () {
      return new URL(href || '');
    }, function () {
      return undefined;
    });
  });
  var urlParams = parsedUrl ? parsedUrl.search.replace(/^\?/g, '').split('&').filter(function (x) {
    return !!x && x.length;
  }) : [];
  return {
    url: parsedUrl ? parsedUrl.toString() : '',
    domain: parsedUrl ? parsedUrl.hostname : '',
    route: parsedUrl ? parsedUrl.pathname : '',
    urlParams: urlParams
  };
};

var getGlobalScope = function getGlobalScope() {
  var globalScope = tryCatch( // eslint-disable-next-line no-undef
  function () {
    return globalThis;
  }, function () {
    return tryCatch(function () {
      return window;
    }, function () {
      return tryCatch(function () {
        return global;
      }, function () {
        return undefined;
      });
    });
  });
  return globalScope;
};

var getGlobalEventData = function getGlobalEventData() {
  var globalScope = getGlobalScope();
  var eventData = globalScope && globalScope.nacelleEventData || {};
  return eventData;
};

var setGlobalEventData = function setGlobalEventData(data) {
  var globalScope = getGlobalScope();

  if (!globalScope) {
    return;
  }

  globalScope.nacelleEventData = _extends({}, globalScope.nacelleEventData, data);
};

var updateSessionEventCount = function updateSessionEventCount() {
  var globalEventData = getGlobalEventData();
  setGlobalEventData({
    sessionEventCount: (globalEventData.sessionEventCount || 0) + 1
  });
};

var tryCatch = function tryCatch(tryFunc, catchFunc) {
  try {
    return tryFunc();
  } catch (error) {
    return catchFunc(error);
  }
};

var constructDataPathPrefix = (function (prefix, parentHandle) {
  if (parentHandle === undefined || parentHandle === null) {
    parentHandle = '';
  } else {
    parentHandle = parentHandle + "/";
  }

  switch (prefix) {
    case 'collection':
      return "data/collections/" + parentHandle;

    case 'page':
      return "data/pages/" + parentHandle;

    case 'product':
      return "data/products/" + parentHandle;

    case 'shop':
      return "data/shop/" + parentHandle;

    case 'article':
      return "data/articles/" + parentHandle;

    case 'blog':
      return "data/blogs/" + parentHandle;

    default:
      return "data/content/" + parentHandle;
  }
});

var defaultTypes = ['product', 'collection', 'page', 'blog', 'article', 'content'];
var DELIMITER = '--';
var constructDataPath = (function (params) {
  var formattedLocal = params.locale.toLowerCase().replace('_', '-');
  var path = "" + params.handle + DELIMITER + formattedLocal;

  if (defaultTypes.indexOf(params.type) === -1) {
    path = "" + path + DELIMITER + params.type;
  }

  var prefix = constructDataPathPrefix(params.type, params.parentHandle);
  return "" + prefix + path + "/static.json";
});

var NacelleStaticConnector = /*#__PURE__*/function (_NacelleConnector) {
  _inheritsLoose(NacelleStaticConnector, _NacelleConnector);

  function NacelleStaticConnector(params) {
    var _this;

    _this = _NacelleConnector.call(this, params) || this;
    _this.basePath = params && params.basePath ? params.basePath : '/';
    return _this;
  }

  var _proto = NacelleStaticConnector.prototype;

  _proto.request = /*#__PURE__*/function () {
    var _request = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(path) {
      var url, response, headers, contentType;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "" + this.basePath + path;
              _context.prev = 1;
              _context.next = 4;
              return this.apiClient.get(url);

            case 4:
              response = _context.sent;

              if (!(response && response.data)) {
                _context.next = 10;
                break;
              }

              headers = new Headers(response.headers);
              contentType = headers.get('content-type');

              if (!(contentType && contentType.includes('application/json'))) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", {
                success: true,
                data: response.data
              });

            case 10:
              throw new Error("Unable to find static resource at " + url);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", {
                success: false,
                error: _context.t0.message,
                data: null
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 13]]);
    }));

    function request(_x) {
      return _request.apply(this, arguments);
    }

    return request;
  }();

  _proto.requestMany = /*#__PURE__*/function () {
    var _requestMany = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(paths) {
      var _this2 = this;

      var requests, responses, successes;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requests = paths.map(function (path) {
                return _this2.request(path);
              });
              _context2.next = 3;
              return Promise.all(requests);

            case 3:
              responses = _context2.sent;
              successes = responses.reduce(function (arr, response) {
                if (response.success && response.data) {
                  arr.push(response.data);
                }

                return arr;
              }, []);
              return _context2.abrupt("return", successes);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function requestMany(_x2) {
      return _requestMany.apply(this, arguments);
    }

    return requestMany;
  }();

  _proto.product = /*#__PURE__*/function () {
    var _product = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(options) {
      var handle, locale, useLocale, path, response;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              handle = options.handle, locale = options.locale;
              useLocale = locale || this.locale;
              path = constructDataPath({
                type: 'product',
                handle: handle,
                locale: useLocale
              });
              _context3.next = 6;
              return this.request(path);

            case 6:
              response = _context3.sent;

              if (!(response.success && response.data)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", createProduct(response.data));

            case 9:
              throw new Error(response.error);

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);

              if (!this.onError) {
                _context3.next = 16;
                break;
              }

              return _context3.abrupt("return", this.onError({
                method: 'product',
                params: options,
                error: _context3.t0
              }));

            case 16:
              throw _context3.t0;

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 12]]);
    }));

    function product(_x3) {
      return _product.apply(this, arguments);
    }

    return product;
  }();

  _proto.products = /*#__PURE__*/function () {
    var _products = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(options) {
      var _this3 = this;

      var handles, locale, useLocale, requests, responses, successes;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              handles = options.handles, locale = options.locale;
              useLocale = locale || this.locale;
              requests = handles.map(function (handle) {
                return _this3.product({
                  handle: handle,
                  locale: useLocale
                })["catch"](function () {
                  return undefined;
                });
              });
              _context4.next = 5;
              return Promise.all(requests);

            case 5:
              responses = _context4.sent;
              successes = responses.reduce(function (arr, response) {
                if (response) {
                  arr.push(response);
                }

                return arr;
              }, []);
              return _context4.abrupt("return", successes);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function products(_x4) {
      return _products.apply(this, arguments);
    }

    return products;
  }();

  _proto.collection = /*#__PURE__*/function () {
    var _collection = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(options) {
      var handle, locale, useLocale, path, response;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              handle = options.handle, locale = options.locale;
              useLocale = locale || this.locale;
              path = constructDataPath({
                type: 'collection',
                handle: handle,
                locale: useLocale
              });
              _context5.next = 6;
              return this.request(path);

            case 6:
              response = _context5.sent;

              if (!(response.success && response.data)) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", createCollection(response.data));

            case 9:
              throw new Error(response.error);

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);

              if (!this.onError) {
                _context5.next = 16;
                break;
              }

              return _context5.abrupt("return", this.onError({
                method: 'collection',
                params: options,
                error: _context5.t0
              }));

            case 16:
              throw _context5.t0;

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 12]]);
    }));

    function collection(_x5) {
      return _collection.apply(this, arguments);
    }

    return collection;
  }();

  _proto.collectionPage = /*#__PURE__*/function () {
    var _collectionPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(options) {
      var handle, locale, list, paginate, index, itemsPerPage, collection, handles;
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              handle = options.handle, locale = options.locale, list = options.list, paginate = options.paginate, index = options.index, itemsPerPage = options.itemsPerPage;
              collection = options.collection;

              if (!(typeof collection === 'undefined')) {
                _context6.next = 11;
                break;
              }

              if (!(handle && handle.length > 0)) {
                _context6.next = 10;
                break;
              }

              _context6.next = 7;
              return this.collection({
                handle: handle,
                locale: locale
              });

            case 7:
              collection = _context6.sent;
              _context6.next = 11;
              break;

            case 10:
              throw new Error('A collection or handle is required');

            case 11:
              handles = getListHandles(collection.productLists, {
                selectedList: list,
                paginate: typeof paginate !== 'undefined' ? paginate : false,
                index: index,
                itemsPerPage: itemsPerPage
              });
              return _context6.abrupt("return", this.products({
                handles: handles,
                locale: locale
              }));

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](0);

              if (!this.onError) {
                _context6.next = 19;
                break;
              }

              return _context6.abrupt("return", this.onError({
                method: 'collectionPage',
                params: options,
                error: _context6.t0
              }));

            case 19:
              throw _context6.t0;

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[0, 15]]);
    }));

    function collectionPage(_x6) {
      return _collectionPage.apply(this, arguments);
    }

    return collectionPage;
  }();

  _proto.content = /*#__PURE__*/function () {
    var _content = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(_ref) {
      var handle, _ref$type, type, locale, _ref$blogHandle, blogHandle, parentHandle, path, response;

      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              handle = _ref.handle, _ref$type = _ref.type, type = _ref$type === void 0 ? 'page' : _ref$type, locale = _ref.locale, _ref$blogHandle = _ref.blogHandle, blogHandle = _ref$blogHandle === void 0 ? 'blog' : _ref$blogHandle;
              _context7.prev = 1;
              parentHandle = type === 'article' ? blogHandle : type === 'product' || type === 'collection' ? 'content' : undefined;
              path = constructDataPath({
                type: type,
                handle: handle,
                locale: locale || this.locale,
                parentHandle: parentHandle
              });
              _context7.next = 6;
              return this.request(path);

            case 6:
              response = _context7.sent;

              if (!(response.success && response.data)) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", createContent(response.data));

            case 9:
              throw new Error(response.error);

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](1);

              if (!this.onError) {
                _context7.next = 16;
                break;
              }

              return _context7.abrupt("return", this.onError({
                method: 'content',
                params: {
                  handle: handle,
                  type: type,
                  locale: locale,
                  blogHandle: blogHandle
                },
                error: _context7.t0
              }));

            case 16:
              throw _context7.t0;

            case 17:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this, [[1, 12]]);
    }));

    function content(_x7) {
      return _content.apply(this, arguments);
    }

    return content;
  }();

  _proto.page = function page(options) {
    return this.content({
      handle: options.handle,
      type: 'page',
      locale: options.locale
    });
  };

  _proto.pages = /*#__PURE__*/function () {
    var _pages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(options) {
      var _this4 = this;

      var handles, locale, useLocale, requests, responses, successes;
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              handles = options.handles, locale = options.locale;
              useLocale = locale || this.locale;
              requests = handles.map(function (handle) {
                return _this4.content({
                  type: 'page',
                  handle: handle,
                  locale: useLocale
                })["catch"](function () {
                  return undefined;
                });
              });
              _context8.next = 5;
              return Promise.all(requests);

            case 5:
              responses = _context8.sent;
              successes = responses.reduce(function (arr, response) {
                if (response) {
                  arr.push(response);
                }

                return arr;
              }, []);
              return _context8.abrupt("return", successes);

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function pages(_x8) {
      return _pages.apply(this, arguments);
    }

    return pages;
  }();

  _proto.blog = function blog(options) {
    return this.content({
      handle: options.handle,
      type: 'blog',
      locale: options.locale
    });
  };

  _proto.article = function article(options) {
    return this.content({
      handle: options.handle,
      type: 'article',
      locale: options.locale,
      blogHandle: options.blogHandle || 'blog'
    });
  };

  _proto.articles = /*#__PURE__*/function () {
    var _articles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(options) {
      var _this5 = this;

      var handles, locale, blogHandle, useLocale, requests, responses, successes;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              handles = options.handles, locale = options.locale, blogHandle = options.blogHandle;
              useLocale = locale || this.locale;
              requests = handles.map(function (handle) {
                return _this5.article({
                  handle: handle,
                  blogHandle: blogHandle,
                  locale: useLocale
                })["catch"](function () {
                  return undefined;
                });
              });
              _context9.next = 5;
              return Promise.all(requests);

            case 5:
              responses = _context9.sent;
              successes = responses.reduce(function (arr, response) {
                if (response) {
                  arr.push(response);
                }

                return arr;
              }, []);
              return _context9.abrupt("return", successes);

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function articles(_x9) {
      return _articles.apply(this, arguments);
    }

    return articles;
  }();

  _proto.blogPage = /*#__PURE__*/function () {
    var _blogPage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(options) {
      var handle, locale, list, paginate, index, itemsPerPage, blog, handles;
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              handle = options.handle, locale = options.locale, list = options.list, paginate = options.paginate, index = options.index, itemsPerPage = options.itemsPerPage;
              blog = options.blog;

              if (!(typeof blog === 'undefined')) {
                _context10.next = 11;
                break;
              }

              if (!(handle && handle.length > 0)) {
                _context10.next = 10;
                break;
              }

              _context10.next = 7;
              return this.blog({
                handle: handle,
                locale: locale
              });

            case 7:
              blog = _context10.sent;
              _context10.next = 11;
              break;

            case 10:
              throw new Error('A blog or handle is required');

            case 11:
              if (!blog.articleLists) {
                _context10.next = 14;
                break;
              }

              handles = getListHandles(blog.articleLists, {
                selectedList: list,
                paginate: typeof paginate !== 'undefined' ? paginate : false,
                index: index,
                itemsPerPage: itemsPerPage
              });
              return _context10.abrupt("return", this.articles({
                handles: handles,
                locale: locale,
                blogHandle: handle || blog.handle
              }));

            case 14:
              return _context10.abrupt("return", []);

            case 17:
              _context10.prev = 17;
              _context10.t0 = _context10["catch"](0);

              if (!this.onError) {
                _context10.next = 21;
                break;
              }

              return _context10.abrupt("return", this.onError({
                method: 'blogPage',
                params: options,
                error: _context10.t0
              }));

            case 21:
              throw _context10.t0;

            case 22:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[0, 17]]);
    }));

    function blogPage(_x10) {
      return _blogPage.apply(this, arguments);
    }

    return blogPage;
  }();

  _proto.space = /*#__PURE__*/function () {
    var _space = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11() {
      var path, response;
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              path = 'data/space.json';
              _context11.next = 3;
              return this.request(path);

            case 3:
              response = _context11.sent;

              if (!(response.success && response.data)) {
                _context11.next = 6;
                break;
              }

              return _context11.abrupt("return", createSpace(response.data));

            case 6:
              throw new Error(response.error);

            case 7:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function space() {
      return _space.apply(this, arguments);
    }

    return space;
  }();

  _proto.allProducts = /*#__PURE__*/function () {
    var _allProducts = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12() {
      var path, response;
      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              path = 'data/search.json';
              _context12.next = 3;
              return this.request(path);

            case 3:
              response = _context12.sent;

              if (!(response.success && response.data && response.data.products)) {
                _context12.next = 6;
                break;
              }

              return _context12.abrupt("return", response.data.products.map(function (product) {
                return createProduct(product);
              }));

            case 6:
              if (!response.error) {
                _context12.next = 8;
                break;
              }

              throw new Error(response.error);

            case 8:
              throw new Error('Unable to get all products from search.json static file.');

            case 9:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function allProducts() {
      return _allProducts.apply(this, arguments);
    }

    return allProducts;
  }();

  return NacelleStaticConnector;
}(NacelleConnector);

var NacelleClient = function NacelleClient(params) {
  if (typeof params.connector === 'undefined') {
    if (typeof params.token === 'undefined' || params.token.length === 0) {
      throw new Error('Nacelle space token is required.');
    }

    if (typeof params.id === 'undefined' || params.id.length === 0) {
      throw new Error('Nacelle space id is required.');
    }

    if (typeof params.nacelleEndpoint === 'undefined' || params.nacelleEndpoint.length === 0) {
      throw new Error('Nacelle endpoint is required');
    }
  } // Set defaults


  this.connector = params.connector; // If a connector is provided, assign the `spaceId` and `token`
  // here. `@nacelle/nacelle-nuxt-module` requires the `id` and
  // `token` be set to the client when generating site data.

  this.id = this.connector ? this.connector.spaceId : params.id;
  this.token = this.connector ? this.connector.token : params.token;
  this.nacelleEndpoint = this.connector ? this.connector.endpoint : params.nacelleEndpoint;
  this.useStatic = typeof params.useStatic !== 'undefined' ? params.useStatic : true;
  this.debugMode = typeof params.debugMode !== 'undefined' ? params.debugMode : false;
  this.defaultLocale = typeof params.locale !== 'undefined' ? params.locale : 'en-us';
  var graphQLConnector; // Set up data connector either from provided connector or
  // constructed from provided v1 credentials.

  if (this.connector) {
    this.data = new NacelleData({
      connector: this.connector,
      locale: this.defaultLocale
    });

    if (typeof this.connector.isVariantAvailable === 'function') {
      this.status = new NacelleStatus({
        connector: this.connector
      });
    }
  } else {
    // Set up connectors
    var dataConnector = new NacelleConnector({
      locale: this.defaultLocale
    });
    var staticConnector = new NacelleStaticConnector({
      basePath: params.staticBasePath,
      locale: this.defaultLocale
    });
    graphQLConnector = new NacelleGraphQLConnector({
      endpoint: this.nacelleEndpoint,
      spaceId: this.id,
      token: this.token,
      locale: this.defaultLocale
    }); // Setup Data module

    if (this.useStatic) {
      dataConnector = staticConnector;
    } else {
      dataConnector = graphQLConnector;
    }

    this.data = new NacelleData({
      connector: dataConnector,
      locale: this.defaultLocale
    });
  } // Setup Events Module


  var eventParams = {};

  if (params.eventsEndpoint) {
    eventParams.endpoint = params.eventsEndpoint;
  }

  if (params.disableEvents) {
    eventParams.disable = params.disableEvents;
  }

  this.events = new NacelleEvents(eventParams); // In the event that `checkout`, `status`, `wishlist` or
  // `recommendations` is needed when a connector is provided,
  // `id`, `token`, and `nacelleEndpoint` must be provided as params.

  if (params.id && params.token && params.nacelleEndpoint) {
    graphQLConnector = new NacelleGraphQLConnector({
      endpoint: params.nacelleEndpoint,
      spaceId: params.id,
      token: params.token,
      locale: this.defaultLocale
    }); // Setup Checkout Module

    this.checkout = new NacelleCheckout({
      connector: graphQLConnector
    }); // Setup Status Module

    this.status = new NacelleStatus({
      connector: graphQLConnector
    }); // Setup WishList module

    var wishlistParams = {
      spaceId: params.id,
      token: params.token
    };

    if (params.wishlistEndpoint) {
      wishlistParams.endpoint = params.wishlistEndpoint;
    }

    this.wishlist = new NacelleWishlist(wishlistParams); // Setup Recommendations module

    var recommendationsParams = {
      spaceId: params.id,
      token: params.token
    };

    if (params.recommendationsEndpoint) {
      recommendationsParams.endpoint = params.recommendationsEndpoint;
    }

    this.recommendations = new NacelleRecommendations(recommendationsParams);
  }
};

export default NacelleClient;
export { HttpClientFetch, NacelleConnector, NacelleGraphQLConnector, NacelleStaticConnector, createCollection, createContent, createItemList, createMedia, createProduct };
//# sourceMappingURL=client-js-sdk.esm.js.map
